import { schema } from 'normalizr'
import { lineSchema } from './lineSchema'

export const networkSchema = new schema.Entity('networks', {
  continuousRoutes: [lineSchema]
})
